import type { AxiosRequestInterceptors, AxiosRequest, AxiosResponse } from '@fanghub/tool-request'
import type { AxiosError } from 'axios'
import { removeToken } from '@/utils/token'
import { initStore } from '@/utils/initStore'
// 网络错误状态码
const NetWorkErrorMap = {
    400: '请求错误',
    401: '未授权，请登录',
    403: '拒绝访问',
    404: '请求错误，未找到该资源',
    405: '请求方法未允许',
    408: '请求超时',
    500: '服务器错误，请联系管理员',
    501: '服务未实现',
    502: '网络错误',
    503: '服务不可用',
    504: '网络超时',
    505: 'HTTP版本不受支持'
}
// 判断当前是否处于登录页，避免在登录页重复弹出重新登录确认框
const isOnLoginPage = (): boolean => window.location.pathname.startsWith('/login')
export const responseHandler: AxiosRequestInterceptors<AxiosRequest, AxiosResponse | any> = {
    // 响应拦截：统一处理后端返回格式
    responseInterceptor: (axiosResponse: AxiosResponse | any) => {
        // 这里校验是不是文件流
        if (!axiosResponse.headers['content-type'].includes('application/json')) {
            return axiosResponse
        }
        const apiResponse = axiosResponse.data as Res<any>
        const { code } = apiResponse
        if (code && code !== 200 && code !== '200' && code !== 0 && code !== '0') {
            if (code === 401) {
                // 已在登录页时直接展示后端返回的错误信息，不再弹重新登录确认框
                if (isOnLoginPage()) {
                    ElMessage.closeAll()
                    ElMessage.error(apiResponse.message)
                    return Promise.reject(apiResponse)
                }
                ElMessageBox.close()
                ElMessageBox.confirm('登录已过期，请重新登录', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        // 删除token
                        removeToken()
                        initStore()
                        window.location.href = `${window.location.origin}/login?redirect=${window.location.pathname}`
                    })
                    .catch(() => {
                        ElMessage.closeAll()
                        ElMessage.info('取消登录')
                    })
            } else {
                ElMessage.closeAll()
                ElMessage.error(apiResponse.message)
            }
        } else {
            return apiResponse
        }
    },
    // 响应错误拦截
    responseInterceptorCatch: (error: any) => {
        if (error.status === 401) {
            // 已在登录页时直接展示后端返回的错误信息，不再弹重新登录确认框
            if (isOnLoginPage()) {
                ElMessage.closeAll()
                ElMessage.error(error.response?.data?.message || '登录已过期，请重新登录')
                return Promise.reject(error)
            }
            ElMessageBox.close()
            ElMessageBox.confirm('登录已过期，请重新登录', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    // 删除token
                    removeToken()
                    initStore()
                    window.location.href = `${window.location.origin}/login?redirect=${window.location.pathname}`
                })
                .catch(() => {
                    ElMessage.closeAll()
                    ElMessage.info('取消登录')
                })
        } else if (error.code === 'ECONNABORTED') {
            ElMessage.closeAll()
            ElMessage.error('响应超时,请联系管理员！')
        } else if (error.status === 400) {
            ElMessage.closeAll()
            ElMessage.error(error.response.data.message)
        } else {
            ElMessage.closeAll()
            // 类型检查确保 error 是 AxiosError 类型
            if (error instanceof Error && 'isAxiosError' in error) {
                const axiosError = error as AxiosError
                const status = axiosError.response?.status
                ElMessage.error((status !== undefined ? NetWorkErrorMap[status] : undefined) || '请求错误')
            } else {
                ElMessage.error('请求错误')
            }
        }
        return Promise.reject(error)
    }
}
